import { css } from "styled-components";

interface CustomInputProps {
  paddingLeft: string | number;
  round: boolean;
  bordered: boolean;
}

const InputHourCustomInput = css<CustomInputProps>`
  .texter-input {
    font-weight: 600;
    color: #278ECD;
    border: 1px solid #ACC2D3;
    background-color: #fff;
    height: 40px;
    ${({ bordered }) =>
      bordered &&
      `
      border: 1px solid #ACC2D3}
    `}
    &:focus{
      border-bottom: 1px solid #5DC5EA;
      border: 1px solid #5DC5EA;
    }
    :disabled {
      color: #ACC2D3;
    }
  }
`;


export default InputHourCustomInput;
